var _style, _g, _defs, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplepay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 82 50",
    style: {
      enableBackground: "new 0 0 82 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#D8D8D8;stroke-miterlimit:10;}\n\t.st2{clip-path:url(#SVGID_00000131369927099144683330000017712814857970454951_);}\n\t.st3{fill:#0B0B09;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,0h66c4.4,0,8,3.6,8,8v34c0,4.4-3.6,8-8,8H8c-4.4,0-8-3.6-8-8V8C0,3.6,3.6,0,8,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8,0.5h66c4.1,0,7.5,3.4,7.5,7.5v34c0,4.1-3.4,7.5-7.5,7.5H8c-4.1,0-7.5-3.4-7.5-7.5V8C0.5,3.9,3.9,0.5,8,0.5z "
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M8,0h66c4.4,0,8,3.6,8,8v34c0,4.4-3.6,8-8,8H8c-4.4,0-8-3.6-8-8V8C0,3.6,3.6,0,8,0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000117678445620724753880000013639706815024725652_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Logo-2",
    style: {
      clipPath: "url(#SVGID_00000117678445620724753880000013639706815024725652_)"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Apple_Pay",
    transform: "translate(16 13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_17",
    className: "st3",
    d: "M5.1,18.7c-1.2,0-2.1-1.1-3-2.3c-0.9-1.3-1.6-2.9-1.9-4.5C-0.1,10.3,0.1,8.5,0.9,7 c0.8-1.4,2.3-2.3,4-2.3h0.1c0.7,0,1.3,0.2,1.9,0.5C7.2,5.4,7.6,5.5,8,5.5c0.4,0,0.8-0.2,1.1-0.3c0.7-0.3,1.5-0.5,2.2-0.5 c0.1,0,0.2,0,0.3,0c1.4,0,2.7,0.7,3.5,1.8l0,0c-1.3,0.7-2,2.1-2.1,3.5c0,1.7,1,3.1,2.6,3.8h0v0c-0.3,0.9-0.8,1.8-1.3,2.6 c-0.7,1.1-1.6,2.3-2.9,2.3h-0.1c-0.5,0-1-0.1-1.4-0.3C9.4,18.1,8.9,18,8.3,18c-0.6,0-1.2,0.1-1.8,0.4C6.1,18.6,5.6,18.7,5.1,18.7 L5.1,18.7z M8.1,4.5L8.1,4.5c-0.1,0-0.1,0-0.2,0c-0.1-1.1,0.3-2.1,1-2.9c0.7-0.8,1.7-1.3,2.8-1.4c0.1,1.1-0.3,2.2-1,3 C10.1,3.9,9.1,4.4,8.1,4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_18",
    className: "st3",
    d: "M21.6,18.5h-1.2V1.8c0.5-0.1,1-0.2,1.6-0.2c0.7-0.1,1.3-0.1,2-0.1c0.9,0,1.8,0.1,2.7,0.4 c0.7,0.2,1.3,0.6,1.8,1c0.4,0.4,0.7,0.9,1,1.4c0.2,0.6,0.4,1.3,0.3,1.9c0,0.8-0.1,1.6-0.5,2.3C29,9.1,28.6,9.7,28,10.1 c-0.6,0.5-1.2,0.8-1.9,1c-0.8,0.2-1.6,0.3-2.5,0.3c-0.7,0-1.4,0-2-0.2L21.6,18.5L21.6,18.5z M24,2.5c-0.5,0-0.9,0-1.4,0.1 c-0.4,0-0.7,0.1-0.9,0.1v7.5c0.3,0.1,0.6,0.1,1,0.2c0.4,0,0.7,0,1.2,0c1.3,0.1,2.5-0.3,3.6-1.1c0.9-0.8,1.3-1.9,1.3-3.1 c0-0.6-0.1-1.2-0.3-1.7c-0.2-0.5-0.5-0.9-0.9-1.2c-0.4-0.3-0.9-0.6-1.5-0.7C25.2,2.6,24.6,2.5,24,2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_19",
    className: "st3",
    d: "M34.4,18.8c-0.5,0-1.1-0.1-1.6-0.3c-0.4-0.2-0.8-0.4-1.1-0.8c-0.3-0.3-0.5-0.7-0.7-1.1 c-0.1-0.4-0.2-0.8-0.2-1.2c0-1.3,0.7-2.6,1.8-3.3c1.6-0.8,3.4-1.2,5.2-1.1h0.3v-0.3c0-0.4,0-0.7-0.1-1.1 c-0.1-0.4-0.2-0.8-0.4-1.2c-0.2-0.4-0.5-0.7-0.9-0.9c-0.5-0.3-1.1-0.4-1.7-0.4c-0.5,0-1.1,0.1-1.6,0.2c-0.5,0.2-1,0.4-1.4,0.7 l-0.4-0.9c0.5-0.4,1.1-0.6,1.7-0.8c0.6-0.2,1.2-0.2,1.8-0.2c0.7,0,1.4,0.1,2.1,0.4c0.5,0.3,0.9,0.6,1.3,1.1 c0.3,0.5,0.5,1,0.6,1.5c0.1,0.5,0.2,1.1,0.2,1.7v4.7c0,0.5,0,1,0,1.5c0,0.5,0.1,0.9,0.2,1.4h-1.1l-0.2-1.7h-0.1 c-0.2,0.3-0.4,0.5-0.6,0.7c-0.3,0.2-0.5,0.5-0.8,0.6c-0.3,0.2-0.7,0.4-1.1,0.5C35.3,18.7,34.8,18.8,34.4,18.8z M37.8,12 c-0.5,0-1.1,0-1.6,0.1c-0.7,0.1-1.3,0.2-2,0.4c-0.6,0.2-1.1,0.5-1.5,1c-0.4,0.5-0.6,1.1-0.6,1.7c-0.1,0.7,0.2,1.4,0.7,1.9 c0.5,0.4,1.1,0.6,1.7,0.6c0.5,0,0.9-0.1,1.3-0.2c0.4-0.1,0.7-0.3,1-0.5c0.3-0.2,0.5-0.5,0.7-0.8c0.2-0.3,0.3-0.6,0.4-0.9 c0.1-0.2,0.1-0.5,0.1-0.7V12C38.1,12,37.9,12,37.8,12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_20",
    className: "st3",
    d: "M41.7,6.5l3.1,7.8c0.2,0.4,0.3,0.9,0.5,1.3c0.2,0.5,0.3,0.9,0.4,1.3h0.1 c0.1-0.4,0.3-0.8,0.4-1.2c0.2-0.5,0.3-0.9,0.5-1.4l2.9-7.8h1.3l-3.6,8.8c-0.4,0.9-0.7,1.8-1,2.5c-0.3,0.8-0.6,1.4-1,2.1 c-0.3,0.6-0.6,1.1-1,1.6c-0.3,0.5-0.7,0.9-1.1,1.2c-0.4,0.4-0.8,0.7-1.3,0.9c-0.4,0.2-0.7,0.3-0.8,0.4l-0.4-1 c0.4-0.2,0.7-0.3,1-0.5c0.4-0.2,0.8-0.5,1.1-0.9c0.4-0.4,0.7-0.8,1-1.2c0.4-0.6,0.7-1.2,1-1.8c0.1-0.2,0.1-0.3,0.2-0.5 c0-0.2-0.1-0.4-0.2-0.5L40.5,6.5H41.7"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplepay);
export default __webpack_public_path__ + "static/media/applepay.db2d07004b6ceddb1d6301e37d1ed739.svg";
export { ForwardRef as ReactComponent };